import Loading from 'components/Loading'
import { CellCentered } from './CellCentered'
import { LoadingCellProps } from './types'

export const LoadingCell = ({ columnsCount }: LoadingCellProps): React.JSX.Element => (
  <CellCentered columnsCount={columnsCount}>
    <Loading />
  </CellCentered>
)
